import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-select-doc-modal',
  templateUrl: './select-doc-modal.component.html',
  styleUrls: ['./select-doc-modal.component.scss']
})
export class SelectDocModalComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<SelectDocModalComponent>) { }

  ngOnInit() {
  }

  onSelected(doc) {
    this.dialogRef.close(doc);
  }
}
